import React, { useEffect, useState, useRef } from 'react';
// import PropTypes from 'prop-types';
import { useContextState } from '../StateProvider';
import useMediaQuery from '../../utils/useMediaQuery';
import { breakpoints } from '../../constants';
import classNames from 'classnames';
import { useTranslation } from 'next-i18next';
import styles from './SearchChips.module.scss';

const SearchChips = () => {
    const { t } = useTranslation('common');
    const [showShowMore, setShowShowMore] = useState(false);
    const [{ activeChips, categories } = {}, dispatch] = useContextState();
    const chips = useRef(null);

    const isMobile = useMediaQuery({
        query: `(max-width: ${breakpoints.l}px)`,
    });

    useEffect(() => {
        if (!chips.current) {
            return;
        }

        const firstChip = chips.current.querySelector('button:first-of-type');
        const lastChip = chips.current.querySelector('button:last-of-type');

        if (!isMobile && firstChip.offsetTop < lastChip.offsetTop) {
            setShowShowMore(true);
        }
    }, [chips, isMobile]);

    const chipsSort = (a, b) => {
        // This sort function will sort by
        // 1) If it is selected
        // 2) Alphabetically

        let aTitle = a.title;
        let bTitle = b.title;

        // Sort by if it's selected or not
        const aIndex = activeChips.indexOf(a.path);
        const bIndex = activeChips.indexOf(b.path);
        if (aIndex > -1 && bIndex === -1) {
            return -1;
        }
        if (bIndex > -1 && aIndex === -1) {
            return 1;
        }

        if (aTitle < bTitle) {
            return -1;
        }
        if (aTitle > bTitle) {
            return 1;
        }
    };

    const chipsClassname = classNames(styles['SearchChips__Chips'], {
        [styles['SearchChips__Chips--ShowMore']]: isMobile || !showShowMore,
    });

    if (!categories || categories.length < 2) {
        return null;
    }

    return (
        <div className={styles['SearchChips']}>
            <div className={styles['SearchChips__SubLabel']}>
                {t('search.categoriesLabel')}
                {activeChips.length > 1 && (
                    <button
                        onClick={() => dispatch({ type: 'clear_chips' })}
                        className={styles['SearchChips__Reset']}>
                        {t('search.clearAll')}
                    </button>
                )}
            </div>
            <div className={styles['SearchChips__ChipsWrap']}>
                <div className={chipsClassname} ref={chips}>
                    {categories.sort(chipsSort).map((item) => {
                        const cls = classNames(styles['SearchChips__Chip'], {
                            [styles['SearchChips__Chip--Active']]:
                                activeChips.indexOf(item.path) > -1,
                        });
                        return (
                            <button
                                key={item.path}
                                onFocus={() => setShowShowMore(false)}
                                onClick={() => {
                                    dispatch({
                                        type: 'toggle_active_chip',
                                        payload: item.path,
                                    });
                                    dispatch({
                                        type: 'set_current_page',
                                        payload: 1,
                                    });
                                    dispatch({
                                        type: 'set_searching',
                                        payload: true,
                                    });
                                }}
                                className={cls}>
                                {item.title}
                            </button>
                        );
                    })}
                </div>
            </div>
            {!isMobile && showShowMore && (
                <button
                    className={styles['SearchChips__ShowMore']}
                    onClick={() => {
                        setShowShowMore(false);
                    }}>
                    {t('search.chipsShowMore')}
                    <span
                        className={styles['SearchChips__Plus']}
                        aria-hidden={true}
                    />
                </button>
            )}
        </div>
    );
};

SearchChips.propTypes = {};

export default SearchChips;
